module.exports = __webpack_public_path__ + "assets/img/17_1044.7472389a.jpg";